/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const incidentPageResponseOutputItemsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const incidentPageResponseOutputItemsItemReceivedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$',
);
export const incidentPageResponseOutputItemsItemPriorityMax = 4;

export const incidentPageResponseOutputItemsItemVersionExclusiveMin = 0;
export const incidentPageResponseOutputItemsItemVersionMax = 9007199254740991;

export const incidentPageResponseOutputItemsItemCustomerOneIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const incidentPageResponseOutputItemsItemTeamOneIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const incidentPageResponseOutputItemsMax = 100;

export const incidentPageResponseOutputNextCursorOneMax = 1024;

export const incidentPageResponseOutputNextCursorOneRegExp = new RegExp('^[A-Za-z0-9_-]+$');

export const IncidentPageResponseOutput = zod.object({
  items: zod
    .array(
      zod.object({
        id: zod.uuid().regex(incidentPageResponseOutputItemsItemIdRegExp),
        title: zod.string(),
        receivedAt: zod.iso
          .datetime({ offset: true })
          .regex(incidentPageResponseOutputItemsItemReceivedAtRegExp),
        sourceKind: zod.enum(['monitoring', 'phone']),
        status: zod.enum(['open', 'acknowledged', 'resolved']),
        priority: zod.int().min(1).max(incidentPageResponseOutputItemsItemPriorityMax),
        version: zod
          .int()
          .gt(incidentPageResponseOutputItemsItemVersionExclusiveMin)
          .max(incidentPageResponseOutputItemsItemVersionMax),
        customer: zod.union([
          zod.object({
            id: zod.uuid().regex(incidentPageResponseOutputItemsItemCustomerOneIdRegExp),
            name: zod.string(),
          }),
          zod.null(),
        ]),
        team: zod.union([
          zod.object({
            id: zod.uuid().regex(incidentPageResponseOutputItemsItemTeamOneIdRegExp),
            name: zod.string(),
          }),
          zod.null(),
        ]),
      }),
    )
    .max(incidentPageResponseOutputItemsMax),
  nextCursor: zod.union([
    zod
      .string()
      .min(1)
      .max(incidentPageResponseOutputNextCursorOneMax)
      .regex(incidentPageResponseOutputNextCursorOneRegExp),
    zod.null(),
  ]),
});

export type IncidentPageResponseOutput = zod.input<typeof IncidentPageResponseOutput>;
export type IncidentPageResponseOutputOutput = zod.output<typeof IncidentPageResponseOutput>;
